import * as React from "react";

import "./Icon.css";
const SvgItemIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Item_Icon_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>
        {
          ".Item_Icon_svg__cls-2{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-width:2px}.Item_Icon_svg__cls-4{fill:currentColor}"
        }
      </style>
    </defs>
    <g transform="translate(0,3)">
      <path
        d="m39.39 8.76.04-.02-24.61-5.71z"
        style={{
          fill: "none",
        }}
      />
      <path
        d="M1 6.71v28.04l26.04 6.84-.03-28.61z"
        className="Item_Icon_svg__cls-2"
      />
      <path
        d="m44.23 7.11-4.8 1.63-.04.02.02 20.64-4.71 1.92-.02-20.95-7.67 2.61.03 28.61 20.05-8.55-.03-26.9z"
        className="Item_Icon_svg__cls-2"
      />
      <path
        d="M34.68 10.37 9.63 4.41l5.19-1.38 24.61 5.71 4.8-1.63 2.88-.98L22.44 1 1 6.71l26.01 6.27z"
        className="Item_Icon_svg__cls-2"
      />
      <path
        d="m39.43 8.74 4.8-1.63-4.8 1.63z"
        style={{
          fill: "none",
          stroke: "currentColor",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="m9.63 4.41 25.05 5.96 1.89-.65 2.82-.96-24.57-5.73z"
        className="Item_Icon_svg__cls-4"
      />
      <path
        d="m34.68 10.37.02 20.95 4.71-1.92-.02-20.64-2.82.96z"
        className="Item_Icon_svg__cls-4"
      />
    </g>
  </svg>
);

export default SvgItemIcon;
